import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import TagManager from 'react-gtm-module';

import ErrorBoundary from '@/_components/error/error_boundary';
import { settings } from '@/_config';
import useIsMounted from '@/_shared/hooks/use-is-mounted';
import { queryClient } from '@/_state/query-client';

import ErrorFallback from './_components/error/error-fallback';
import getTheme from './_shared/themes';
import { router } from './router';

if (settings.isATP && settings.isStaging) {
  TagManager.initialize({
    gtmId: 'GTM-KNJSPJFN',
  });
}
/**
 * Entry point for app logic
 * All global initializations and declarations are done here
  
 * <ThemeProvider: Provide theme context to all code
 * <CssBaseline: Initialize all base css for old browsers
 * <ErrorBoundary: Capture unwanted bugs
 * <Administrator: Initializing snack bars loaders, login etc.
 * <RouterProvider: Main router for the app
 */

function EntryPoint() {
  const theme = getTheme();

  useIsMounted(() => {
    const elm = document.getElementById('preloader');
    if (typeof elm !== 'undefined' && elm !== null) {
      elm.style.display = 'none';
    }
  });

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ErrorBoundary FallbackComponent={<ErrorFallback />}>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID as string}>
              <RouterProvider router={router} />
            </GoogleOAuthProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}

export default EntryPoint;
